module.exports = __webpack_public_path__ + "static/xxpeed-xp-4-028b1ba0790c6a6b5d09bf1e623ba2cc.jpg";